export default{
  platform: 'Plataforma',
  admindigital: 'Admin Digital',
  artiflow: 'Artiflow',
  dashconnect: 'Dash Connect',
}